/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
// tslint:disable-next-line: no-duplicate-imports
import { IActionContext } from '@msdyn365-commerce/core';
import { CacheType } from '@msdyn365-commerce/retail-proxy';
import { mFIGetBonusItemsDetailAsync } from '../actions/BonusItemDataActionExtension.g';
import { IMFIBonusItemsResponse, IMFIGetBonusItemsParameters } from '../actions/BonusItemDataServiceEntities.g';
import { hasArray } from '../Utilities/emtpyChecker';
import { _getMFIGetBonusItems } from '../Utilities/get-bonus-items';

/**
 * GetBonusCouponInfo Input Action
 */

export class GetBonusCouponInfoInput implements Msdyn365.IActionInput {
    public cartId?: string;
    public coupons?: string[];

    constructor(cartId: string, coupons: string[]) {
        this.cartId = cartId;
        this.coupons = coupons;
    }
    public getCacheKey = () => `Get-Coupon-Info-${this.coupons}`;
    public getCacheObjectType = () => `GetCouponInfo`;
    public dataCacheType = (): CacheType => 'application';
}

export async function getCouponInfo(input: GetBonusCouponInfoInput, ctx: IActionContext): Promise<IMFIBonusItemsResponse | null> {
    const requestBodyMFIBonus: IMFIGetBonusItemsParameters = {
        CartId: input.cartId,
        Coupons: input.coupons
    };
    let result = null;
    if (requestBodyMFIBonus && requestBodyMFIBonus.CartId && hasArray(requestBodyMFIBonus.Coupons)) {
        try {
            if (!result) {
                result = await mFIGetBonusItemsDetailAsync({ callerContext: ctx }, requestBodyMFIBonus);
                if (result) {
                    return result;
                }
            }
        } catch (error) {
            console.log('Error', error);
        }
    }
    return result;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IMFIBonusItemsResponse | null>>getCouponInfo,
    id: 'get-bonus-coupon-info'
});
